import { Divider, Menu } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { screenSize } from '@src/constants/ScreenSize';
import {
    THEME,
    selectLayout,
    setCollapsed,
    setSelectedMenuKey,
} from '@src/store/layout/layoutSlice';
import { StyledMenuItem, StyledSubMenuItem } from './styles';
import useSidebarMenuItems from './useSidebarMenuItems';
import { ISidebarItemGroup } from './types';
import clsx from 'clsx';
import { PiSignOutBold } from 'react-icons/pi';
import { useAuth0 } from '@auth0/auth0-react';
import { logout } from '@src/store/user/userSlice';
import { HiOutlineChatBubbleLeftRight } from 'react-icons/hi2';
import SupportForm from '@src/components/SupportForm';
import { useState } from 'react';

function TopicMenu() {
    const dispatch = useDispatch();
    const layout = useSelector(selectLayout);
    const isLg = useMediaQuery({ minWidth: screenSize.lg });
    const { items } = useSidebarMenuItems();
    const { logout: authLogout } = useAuth0();
    const [supportModal, setSupportModal] = useState(false);
    const onClickItem = (item) => {
        if (!isLg) {
            dispatch(setCollapsed(true));
        }
        dispatch(
            setSelectedMenuKey({
                key: item.key,
                label: item.domEvent.target.text,
            })
        );
    };
    const handleSingOut = () => {
        dispatch(logout(undefined));
        authLogout({
            logoutParams: {
                returnTo: window.location.origin,
            },
        });
    };
    const toggleSupport = () => {
        setSupportModal(!supportModal);
    };
    return (
        <>
            {supportModal && (
                <SupportForm open={supportModal} onClose={toggleSupport} />
            )}
            <Menu
                theme={layout.theme}
                mode="inline"
                defaultSelectedKeys={['dashboard']}
                selectedKeys={[layout.key.key]}
                onClick={onClickItem}
                className={`text-sm !border-none !bg-transparent ${
                    layout.theme === THEME.LITHE
                        ? '!text-primary'
                        : '!text-white'
                }`}
            >
                {items.map((item: ISidebarItemGroup, index) =>
                    item.type === 'divider' ? (
                        <Divider
                            className={'bg-primary/20 my-2'}
                            key={item.key}
                        />
                    ) : item.items ? (
                        <StyledSubMenuItem
                            key={item.key}
                            title={item.label}
                            icon={item.icon}
                            disabled={item.disabled}
                            className={clsx(
                                'active:bg-transparent',
                                item.disabled ? 'pointer-events-none' : '',
                                layout.theme === THEME.LITHE
                                    ? '!text-primary'
                                    : '!text-white'
                            )}
                        >
                            {item.items &&
                                item.items.map((child) => (
                                    <Menu.Item
                                        key={child.key}
                                        disabled={child.disabled}
                                        className={clsx(
                                            'active:bg-transparent',
                                            child.disabled
                                                ? 'pointer-events-none'
                                                : '',
                                            layout.theme === THEME.LITHE
                                                ? '!text-primary'
                                                : '!text-white'
                                        )}
                                    >
                                        {child.label}
                                    </Menu.Item>
                                ))}
                        </StyledSubMenuItem>
                    ) : (
                        <StyledMenuItem
                            key={item.key}
                            icon={item.icon}
                            style={
                                index === 0
                                    ? {
                                          /*marginTop: '50px'*/
                                      }
                                    : { marginBlock: 0 }
                            }
                            disabled={item.disabled}
                            className={clsx(
                                item.disabled ? 'pointer-events-none' : '',
                                layout.theme === THEME.LITHE
                                    ? clsx(
                                          '!text-primary text-base font-normal !pl-4',
                                          layout.collapsed ? '!h10' : '!h-14'
                                      )
                                    : '!text-white'
                            )}
                        >
                            {item.label}
                        </StyledMenuItem>
                    )
                )}
            </Menu>
            <div className="!absolute bottom-0 w-full text-[#000000E0]">
                <Divider className={'bg-primary/20 my-2'} />
                <div
                    onClick={toggleSupport}
                    className="flex gap-3 ml-5 my-6 cursor-pointer text-base font-normal"
                >
                    <HiOutlineChatBubbleLeftRight className="w-4 h-4" />
                    {layout.collapsed ? '' : 'Support'}
                </div>
                <Divider className={'bg-primary/20 my-2'} />
                <div
                    key="logout"
                    onClick={handleSingOut}
                    className="flex gap-3 ml-5 my-6 cursor-pointer text-base font-normal"
                >
                    <PiSignOutBold className="w-4 h-4" />{' '}
                    {layout.collapsed ? '' : 'Logout'}
                </div>
            </div>
        </>
    );
}

export default TopicMenu;
